import PipeEnd from './ProductionPipe';

function addEntities(scene) {
  scene.pipeEnd = new PipeEnd({
    scene,
  });

  scene.entities = [
    scene.pipeEnd,
  ];
}

export default addEntities;
